import { ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {SelectionModel} from '@angular/cdk/collections';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { FormsService } from '../../services/forms.service';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from '../../../../middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { Observable, Subscription } from 'rxjs';
import { ProjectTempType, RoleLevel } from '../../services/form.enum';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup } from '@angular/forms';
declare var require: any;
const FileSaver = require('file-saver');
import { COMMA, ENTER, F } from '@angular/cdk/keycodes';
import * as moment from 'moment';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';

enum Status {
  Sent = 1,
  Inprogress = 2,
  Completed = 3,
}

@Component({
  selector: 'app-sent',
  templateUrl: './sent.component.html',
  styleUrls: ['./sent.component.scss']
})

export class SentComponent implements OnInit {

  databaseId: string;
  organizationId: string;
  currentUser: any;
  sentProjectsList: any[] = [];  
  displayedColumns: string[] = [];
  displayedColumnsAdvSearch: string[] = [];
  dataSource: any;
  selection = new SelectionModel<any>(true, []);
  _returnList: any[] = [];
  _returnColumns: any[] = [];
  Module:string;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  paginatorTotalLength:any;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };  
  SelectedRecordForDeleFav:boolean=false;
  selectedRecordDeleteArray: any = [];
  noRecordFound:boolean = false; 
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  docDetail:boolean = false;
  groupDetail:boolean = false;
  showmyDrive:boolean = false;
  value = '';
  pageIndex: any;
  pageSize: any;
  ParticipantList:any=[];
  projectId:number=0;
  projectInboxSentId:number=0;
  clickEventsubscription : Subscription;
  rolesAsssign: any[] = [];
  ShowMasterTemplate:boolean=false;
  selectedSentItem:any;
  OfficeIDList: any=[];
  myOfficeID: any;
  isOrganizationAdmin:boolean=false;
  isOfficeAdmin:boolean=false;
  //showAdvSearchList:boolean=false;
  CoreShowName: string = '';
  ContactShowName: string = '';
  CompanyShowName: string = '';
  menuModulesList:any=[]=[];

  constructor(private router: Router,private dialog: MatDialog,private formsService:FormsService,
    private reusableClass:ReusableClasses,private encryptionAlgo: EncryptionService,
    private _dataSharingService: DataSharingService, private cdr: ChangeDetectorRef,
    private loaderService: LoaderService, private toastr: ToastrService,
    private statusConst: StatusConstant,) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      this.currentUser = jwt_decode(token);
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
     }  
  
  ngAfterContentChecked() {
    this.cdr.detectChanges();
   }

  ngOnInit(): void {
    this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Core'
    );
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;     
    }

    SelectedContact = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Contact'
    );
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;      
    }

    SelectedCompany = this.menuModulesList.filter(
      (x) => x.mainModuleName == 'Company'
    );
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;   
    }

    sessionStorage.setItem('edashboard', "false");
    this.paginatorTotalLength=0;
    this.getSentProjects(this.pageModelData);
    //this.setDisplayedColumns();
    this.setDisplayedColumnsAdvSearch();
    this.clickEventsubscription = this._dataSharingService.getSentSelectedDetail().subscribe((result) => {
       if(result){ 
        
        this.showParticipantDetail(result);
       }
     });
  
     this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
     if(this.rolesAsssign.length > 0){
       var role=[];
       var roleOrg=[];
       var roleOffice=[];
       // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
       role= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
       if(role.length > 0){
        this.ShowMasterTemplate = true;
       }else{
         this.ShowMasterTemplate = false;
       }
       roleOrg= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OrganizationAdmin);
       if(roleOrg.length > 0){
        this.isOrganizationAdmin = true;
       }else{
         this.isOrganizationAdmin = false;
       }

       roleOffice= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.OfficeAdmin);
       if(roleOffice.length > 0){
        this.isOfficeAdmin = true;
       }else{
         this.isOfficeAdmin = false;
       }
     }  
   }

  CreatePdfForm(Option){
    // True-Create PDF Form
    // False-Create Master Template PDF Form
    if(Option==false){
      sessionStorage.setItem('MasterTemplatePDFForm','true');
      sessionStorage.setItem('type',(ProjectTempType.Template).toString());
    }else{
      sessionStorage.setItem('MasterTemplatePDFForm','false');
      sessionStorage.setItem('type',(ProjectTempType.Project).toString());
    }
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");  
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.setItem('MasterOrgTemplatePDFForm','false');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.removeItem('categoryID');
    sessionStorage.setItem('FolderOpenId','0');
    sessionStorage.setItem('FolderOpenName',''); 
    this._dataSharingService.sendSelectedProjectName("");
    this.router.navigate(['/esignature/first']);
  }
  
  CreateHTMLForm(Option){    
    if(Option==false){
      sessionStorage.setItem('MasterGlobalTemplateWebForm','true');
      sessionStorage.setItem('MasterOrgTemplateWebForm','false');     
    }else{
      sessionStorage.setItem('MasterTemplateWebForm','true');
      sessionStorage.setItem('MasterOrgTemplateWebForm','false');
    }
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");   
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.removeItem('categoryID');
    sessionStorage.setItem('FolderOpenId','0');
    sessionStorage.setItem('FolderOpenName','');   
    this._dataSharingService.sendSelectedProjectName("");
    this._dataSharingService.sendSelectedModuleName('Forms');
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.router.navigate(['/esignature/htmlform']);
  }
  
  CreateAuditForm(Option){
    // True-Create Tabular Form
    // False-Create Master Template Tabular Form
    if(Option==false){
      sessionStorage.setItem('MasterTemplateTabularForm','true');
    }else{
      sessionStorage.setItem('MasterTemplateTabularForm','false');
    }
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");
    sessionStorage.setItem('type',(ProjectTempType.Template).toString());
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.removeItem('categoryID');
    sessionStorage.setItem('FolderOpenId','0');
    sessionStorage.setItem('FolderOpenName','');   
    this._dataSharingService.sendSelectedProjectName("");
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.router.navigate(['/esignature/firsttabular']);
  }

  resetProject(sent){
    sessionStorage.setItem('projectID',sent.projectID);
    sessionStorage.setItem('stepCompleted','0');
    sessionStorage.setItem('type',(ProjectTempType.Project).toString());
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.setItem('isSent','true');
    sessionStorage.setItem('MasterTemplatePDFForm','false');
    sessionStorage.setItem('MasterTemplateTabularForm','false');
    this.router.navigate(['/esignature/first']);
  }


  StatusType = "All";
  
  filterSentType(event: any){
    this.StatusType = event;
    this.pageModelData.pageIndex=0;
    this.pageModelData.pageSize=10;
    this.pageModelData.searchValue="";
    //this.showAdvSearchList=false;
    this.getSentProjects(this.pageModelData);
    // this.StatusType = event;
    // let proList = this.sentProjectsList;
    
    // this.dataSource.data = proList;
    
    // if(event == "Progress"){
    //   let list = proList.filter(x => x.status === 2);
    //   this.dataSource.data = list;
    // }else if(event == "Completed"){
    //   let list = proList.filter(x => x.status === 3);
    //   this.dataSource.data = list;
    // }else if(event == "Sent"){
    //   let list = proList.filter(x => x.status === 1);
    //   this.dataSource.data = list;
    // }
      
  }



  getSentProjects(pageData: any) {
    var status;
    if(this.StatusType=="All"){
      status=null;
    }
    if(this.StatusType=="Completed"){
      status=[3];
    }
    if(this.StatusType=="Progress"){
      status=[2];
    }
    if(this.StatusType=="Sent"){
      status=[1];
    }
   // this.pageIndex = pageData.pageIndex;
   // this.pageSize = pageData.pageSize;
    var reqModelSearch={
      nameEmail: "",
      projectName: this.pageModelData.searchValue,   
      author:"",
      formID: Number(0),    
      dateRange: {
        from:null,
        to: null
      },      
      status: status,//[1,2,3],     
      pageIndex:this.pageModelData.pageIndex,
      pageSize:this.pageModelData.pageSize,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList:this.OfficeIDList,
      sortColumn:"CreatedOn",
      sortDirection:"desc",
      isPaging:true   
    }
    //return;
    this.loaderService.show();
    this.formsService.pdfProjectAdvancedSearch(reqModelSearch).subscribe(response=>{
    // var ReqModel = {
    //   pageIndex:this.pageModelData.pageIndex,
    //   pageSize:this.pageModelData.pageSize,
    //   searchKey:this.pageModelData.searchValue,
    //   status:status,
    //   userID: this.currentUser.UID,
    //   organizationID: Number(this.organizationId),
    //   OfficeID:this.myOfficeID,
    //   databaseID: Number(this.databaseId),
    // }
    // this.loaderService.show();    
    // this.formsService.getSentProjects(ReqModel).subscribe(response=>{
      if(response.data!=null){
        this.dataSource = new MatTableDataSource<any>();
        if(response.data.searchResults!=null){
          response.data.searchResults.forEach(e =>{
            e.signingToken=window.location.href.split(window.location.pathname)[0]+"/request/signature?token="+e.signingToken+"&IsReadOnlyFromsignaturePage=true"
           });
        }
       
        this.sentProjectsList = response.data.searchResults;
        if(this.sentProjectsList!=null){
          this.sentProjectsList.map((res) => {
         
            if (res.authorFirstName != null) {
              res.authorFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.authorFirstName);
            }
            if (res.authorLastName != null) {
              res.authorLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.authorLastName);
            }    
            if (res.authorFirstName != null || res.authorLastName != null){
              res.authorFullName= res.authorFirstName+" "+res.authorLastName;
            }
            return res;
          }); 
        }
            
        this.sentProjectsList = response.data.searchResults;
        
        //this.showAdvSearchList=true;
        this.sentProjectsList = response.data.searchResults;
        this.dataSource.data =this.sentProjectsList;   
        this.dataSource.sort = this.sort;    
        this.paginatorTotalLength = response.data.total;
        this.pageModelData.pageIndex = response.data.pageIndex;
        this.pageIndex = response.data.pageIndex;
        this.pageSize = this.pageModelData.pageSize
        
        if(this.sentProjectsList!=null){
         this.noRecordFound=false;
       }else{
        this.noRecordFound=true;
        this.SelectedRecordForDeleFav=false;
        this.selection.clear();
       }
       this.dialog.closeAll();
       this.loaderService.hide();
      }else{
       this.paginatorTotalLength=0;
       this.loaderService.hide();
      }
     });  
  }

  setDisplayedColumns() {
    this.displayedColumns  = ['projectId','subject','projectName',  'sentOn','status','action'];
  }

  setDisplayedColumnsAdvSearch() {
    this.displayedColumnsAdvSearch  = ['projectId','status','name','Active','authorName', 'Assignee', 'sentOn','attachType','action'];
  }
 

  SearchFilter() { 
    this.selection.clear(); 
    //this.showAdvSearchList=false;
    this.SelectedRecordForDeleFav=false;
    this.pageModelData.pageIndex=0;
    this.pageModelData.searchValue; 
    if(this.pageModelData.searchValue==""){
      return;
     }
     this.emailAdvSearch=this.pageModelData.searchValue;
     this.ProjectName = this.pageModelData.searchValue;
     this.isAdvancedSearch=false;
     this.searchAdvFilter();
    //this.getSentProjects(this.pageModelData);
  }

  Search(filterValue) {
    this.selection.clear(); 
    this.SelectedRecordForDeleFav=false;
    //this.showAdvSearchList=false;
    this.pageModelData.pageIndex=0;
    this.pageModelData.searchValue=filterValue.trim();
    this.emailAdvSearch=filterValue.trim();
    this.ProjectName =filterValue.trim();
    this.isAdvancedSearch=false;
    this.searchAdvFilter();
    //this.getSentProjects(this.pageModelData);
  }

  pageEventPropogate(pageData: PageEvent) { 
    // if(this.showAdvSearchList==false){
    //   this.pageModelData.pageIndex = pageData.pageIndex;
    //   this.pageModelData.pageSize = pageData.pageSize;
    //   this.pageModelData.searchValue;
    //   this.getSentProjects(this.pageModelData);   
    // }
   // if(this.showAdvSearchList==true){
      this.pageModelData.pageIndex = pageData.pageIndex;
      this.pageModelData.pageSize = pageData.pageSize;
      //this.pageModelData.searchValue;
      this.searchAdvFilter();   
    //}   
  }

 /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
  const numSelected = this.selection.selected.length;
  const numRows = this.dataSource.data.length;
  return numSelected === numRows;
  }

/** Selects all rows if they are not all selected; otherwise clear selection. */
 masterToggle() {
  this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => {
        this.selection.select(row)});
        this.selectedRecordDeleteArray=[];    
      
        if (this.selection.selected.length > 0) {
          for (let i = 0; i < this.selection.selected.length; i++) {          
              let ReqModel = {
                selectedRecord: this.selection.selected[i].projectInboxSentId
                   };
               this.selectedRecordDeleteArray.push(ReqModel);    
          }
          this.SelectedRecordForDeleFav = true;
        }
        else {
          this.SelectedRecordForDeleFav = false;
          this.selectedRecordDeleteArray = [];
        }     
 }

  isAllSelectedRow(event, element) {
    let ReqModel = {
      selectedRecord: element.projectInboxSentId
    };
    if (event.checked) {
      this.selectedRecordDeleteArray.push(ReqModel);
    } else {
      let removeIndex = this.selectedRecordDeleteArray.findIndex(
        (itm) => itm.selectedRecord === element.projectInboxSentId);
      if (removeIndex !== -1) this.selectedRecordDeleteArray.splice(removeIndex, 1);
    }
    if (this.selectedRecordDeleteArray.length > 0) {
      this.SelectedRecordForDeleFav = true;
    }
    else {
      this.SelectedRecordForDeleFav = false;
      this.selectedRecordDeleteArray = [];
    } 
  }

  deleteSentProjects(){
    const message = `Are you sure you want to move selected record to the trash?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
  
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          let selectedProjectIds=[];
          this.selectedRecordDeleteArray.forEach(element => {            
            selectedProjectIds.push(element.selectedRecord);
          });
          let rqModel = {
            projectInboxSentId: selectedProjectIds,
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
            isTrashed:true
          }        
          this.formsService.DeleteSentProjects(rqModel).subscribe(response=>{
            if(response.data==true){
              this.SelectedRecordForDeleFav = false;
              this.pageModelData.searchValue="";
              this.getSentProjects(this.pageModelData);
            }
          })
          this.SelectedRecordForDeleFav = false;
          this.selectedRecordDeleteArray = [];
          this.selection.selected.forEach(item => {
            let index: number = this.dataSource.data.findIndex(d => d === item);  
            this.dataSource.data.splice(index, 1)
            this.dataSource = new MatTableDataSource<Element>(this.dataSource.data);
          });
          this.selection = new SelectionModel<Element>(true, []);
        }
        else{
          this.selectedRecordDeleteArray=[];
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });
  }
  
  movetoTrash(projectInboxSentId){
      this.selectedRecordDeleteArray=[];
      this.selectedRecordDeleteArray.push({selectedRecord:projectInboxSentId});
      const message = `Are you sure you want to move selected record to the trash?`;
      const title = `Confirm`;
      const confirm = `Confirm`;
      const dialogData = new ConfirmDialogModel(title, message,confirm);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'edituserdetails',
        maxWidth: '1000px',
        maxHeight: '500px',
        data: dialogData,
      });
    
      dialogRef.beforeClosed().subscribe(async (dialogResult) => {
        try {
          if (dialogResult) {
            let selectedProjectIds=[];
            this.selectedRecordDeleteArray.forEach(element => {              
              selectedProjectIds.push(element.selectedRecord);
            });
            let rqModel = {
              projectInboxSentId: selectedProjectIds,
              userID: this.currentUser.UID,
              organizationID: Number(this.organizationId),
              databaseID: Number(this.databaseId),
              isTrashed: true
            }
            this.formsService.DeleteSentProjects(rqModel).subscribe(response=>{           
              if(response.data==true){
                this.SelectedRecordForDeleFav = false;
                this.pageModelData.searchValue="";
                this.getSentProjects(this.pageModelData);
              }
            })
            this.SelectedRecordForDeleFav = false;
            this.selectedRecordDeleteArray = [];
            this.selection.selected.forEach(item => {
              let index: number = this.dataSource.data.findIndex(d => d === item);  
              this.dataSource.data.splice(index, 1)
              this.dataSource = new MatTableDataSource<Element>(this.dataSource.data);
            });
            this.selection = new SelectionModel<Element>(true, []);
          }
          else{
            this.selectedRecordDeleteArray=[];
          }
        } catch (e) {          
        }
      });
  }
  

  showDocDetail(){
    this.docDetail = !this.docDetail
  }
  
  showMyDrive(){
    this.showmyDrive = !this.showmyDrive
  }

  close() {
    this.ParticipantList=[];
    this.dialog.closeAll();
  }

  getShortName(fullName) {
    const splitName = fullName.split(' ').map(n => n[0]).join('');
    return splitName ? splitName : "-"
  }
 
  getShortNameAuthor(authorFirstName,authorLastName) {
    var fullName =authorFirstName+" "+authorLastName;
    const splitName = fullName.split(' ').map(n => n[0]).join('');
    return splitName ? splitName : "-"
  }

  closeDetail(){
    this.groupDetail = false;
  }

  showParticipantDetail(sent){
    this.groupDetail = true;
    this.projectInboxSentId=sent.projectInboxSentId;
    if(this.formsService.getIsprojectExtended()){
      this.getSentProjects(this.pageModelData);     
    }
    this.projectId=sent.projectID;
    this.selectedSentItem = sent;
    this.selectedSentItem.projectName = sent.name;
    var ReqModel = {
      projectID:sent.projectID,
      projectInboxSentID:0,
      emailFieldID:0,
      nameFieldID:0,     
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    }
    this.formsService.GetSentBoxItemParticipantList(ReqModel).subscribe(response=>{
     if(response.data!=null){      
      this.formsService.setIsprojectExtended(false);   
       this.ParticipantList = response.data;  
       this.ParticipantList.forEach(e => {
        e.getProjectGroupRelationParticipantMappingModelList.forEach(n => { 
        n.enableEmailEdit=false;
        n.signingToken=window.location.href.split(window.location.pathname)[0]+"/request/signature?token="+n.signingToken
        });
      });      
     }else{
    }
    });
  }

  viewDetail(templateRef: TemplateRef<any>,sent) {
    return;
    const dialogRef = this.dialog.open(templateRef,{
      panelClass: 'SentProjectDetail'
    })
  }

  //download selected File
  downloadDocument(sent) {
    var ReqModel={
       projectID: sent.projectID,
       type: sent.projectType,
       isSent: true,
       userID: this.currentUser.UID,
       organizationID: Number(this.organizationId),
       officeID: this.myOfficeID,     
       databaseID: Number(this.databaseId)
     }  
     this.loaderService.show();
     this.formsService.getProjectFinalDocuments(ReqModel).subscribe(response=>{
     if(response.data!=null){ 
       var fileList=[];
       fileList=response.data.documents;
       if(fileList.length>0){
        for (let i = 0; i < fileList.length; i++) {
          const selectedFileName = fileList[i].azureblobPath.split('/').pop();
          this.formsService.getAttachment(selectedFileName, fileList[i].azureblobPath).subscribe((response) => {
          if (response !== undefined) {
            const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
            FileSaver.saveAs(data, selectedFileName);
           }else{
             this.toastr.error('File download failed.', '', {
              timeOut: 3000,
             });
            }
          });
         }
       }
       this.loaderService.hide();
      }else{
        this.loaderService.hide();
      }
     });   
   }

   fileManagerFolderReportList:any=[]=[];
   fileTypes:any=[]=[];
   fileType:string="All";
   fileTypeSelected:number=1;
   filterByDate:any="";
   Filters:any={};
   fileManagerItemID:number=0;
   TypeIdDrp:number=0;
   documentTypeList:any=[]=[];
   coreUserList:any=[]=[];
   coreFieldSaveCompare:any=[]=[];
   coreFieldList:any=[]=[];
   myFormGroup: FormGroup;
   dropdownlist: any=[]=[];
   dropdownlistType: any;
   newdropdownlist: any;  
   multipleDropdownList: any;
   checkBoxList: any;
   newcheckBoxList: any;
   chkStatusArry: any;
   TypeList:any;
   tagCtrl = new FormControl();
   filteredTags: Observable<string[]>;
 
   newtag: string[] = [];
   tags: string[] = [];
   allTags: string[] = [];
   AllTagList: any;
   selectedtagsId: any = [];
   cityOption: string[]=[];
   filteredOptions: Observable<string[]>;
   fruitCtrl = new FormControl();
   filteredFruits: Observable<string[]>;
   @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
   visible = true;
   selectable = true;
   removable = true;
   separatorKeysCodes: number[] = [ENTER, COMMA]; 
   TypeListForDropDown:any=[]=[];
   minFromDate: Date;
   maxFromDate: Date | null;
   minToDate: Date | null;
   maxToDate: Date;
   fromDate: any;
   toDate: any;
   DocSizeFrom:any;
   DocSizeTo:any;
   userList:any=[]=[];
   timeout = null;

   isAISearch:boolean=false;
   documentName:string="";
   isExactDocumentName:boolean=false;
   Tagkeywords:string="";
   isExactKeywords:boolean=false;
   authorBy:string="";
   authorByValue:string="";
   arryaControlNameIdpare: any=[];
   tagvalues: string;
   spinner:boolean=false;

   emailAdvSearch:string="";
   ProjectName:string="";
   subject:string="";
   selectedFormId:number=0;
   formList:any=[]=[];
   userData: any[] = [];
   sentchecked:boolean=false;
   inProgresschecked:boolean=false;
   completedchecked:boolean=false;
   userListResponseHolder:any=[]=[];
   projectDocuments:any=[]=[];
   ResponseHolderDetails:any=[]=[];
   documentId:number=0;
   sentby:string="";
   isAdvancedSearch:boolean=false;

   applyAdvFilter(templateRef: TemplateRef<any>) {
    this.isAdvancedSearch=true;
    this.sentchecked=false;
    this.completedchecked=false;
    this.inProgresschecked=false;
    this.userData=[];
    this.emailAdvSearch="";
    this.ProjectName="";
    this.subject="";
    this.selectedFormId=0;
    this.fromDate="";
    this.toDate="";    
    this.formList=[];
    this.documentId=0
    this.sentby="";
    this.getFormsList();  
    if(this.isOrganizationAdmin==true){
      this.getUserListAll(); 
    }
     this.pageModelData.pageIndex=0;
     this.pageModelData.pageSize=this.pageModelData.pageSize;
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  searchAdvFilter(){    
    if(this.fromDate==""){
      this.fromDate=null;
    }
    if(this.fromDate!=null){
      this.fromDate = moment(this.fromDate).format("MM/DD/YYYY");
    }
    if(this.toDate==""){
      this.toDate=null;
    }
    if(this.toDate!=null){
      this.toDate = moment(this.toDate).format("MM/DD/YYYY");
    }   

    let status = [];
    if(this.sentchecked==false && this.inProgresschecked==false && this.completedchecked==false){
      status=null;
    }

    if(this.sentchecked==true){
      status.push(1);
    }
    if(this.inProgresschecked==true){
      status.push(2);
    }
    if(this.completedchecked==true){
      status.push(3);
    }
    // if(this.pageModelData.pageIndex==0){
    //   this.pageModelData.pageIndex=1;
    //   this.pageModelData.pageSize=this.pageModelData.pageSize;
    // }    
    // this.pageModelData.pageIndex = this.pageModelData.pageIndex;
    // this.pageModelData.pageSize = this.pageModelData.pageSize;

    var reqModelSearch={
      nameEmail: this.emailAdvSearch,
      projectName: this.ProjectName,     
      author:this.sentby,
      formID: Number(this.selectedFormId),
     // docID:this.documentId,      
      dateRange: {
        from: this.fromDate,
        to: this.toDate
      },  
     // fileType:this.fileType,
      //subject: this.subject,    
      status: status,//[1,2,3],     
      pageIndex:this.pageModelData.pageIndex,
      pageSize:this.pageModelData.pageSize,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList:this.OfficeIDList,
      sortColumn:"CreatedOn",
      sortDirection:"desc",
      isPaging:true,
      isAdvancedSearch:this.isAdvancedSearch
    }
    //return;
    this.loaderService.show();
    this.formsService.pdfProjectAdvancedSearch(reqModelSearch).subscribe(response=>{
      if(response.data!=null){
        this.dataSource = new MatTableDataSource<any>();
        if(response.data.searchResults!=null){
          response.data.searchResults.forEach(e =>{
            e.signingToken=window.location.href.split(window.location.pathname)[0]+"/request/signature?token="+e.signingToken+"&IsReadOnlyFromsignaturePage=true"
           });
        }
       
        this.sentProjectsList = response.data.searchResults;
        if(this.sentProjectsList!=null){
          this.sentProjectsList.map((res) => {
         
            if (res.authorFirstName != null) {
              res.authorFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.authorFirstName);
            }
            if (res.authorLastName != null) {
              res.authorLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.authorLastName);
            }    
            if (res.authorFirstName != null || res.authorLastName != null){
              res.authorFullName= res.authorFirstName+" "+res.authorLastName;
            }
            return res;
          }); 
        }
            
        this.sentProjectsList = response.data.searchResults;
        
        //this.showAdvSearchList=true;
        this.sentProjectsList = response.data.searchResults;
        this.dataSource.data =this.sentProjectsList;   
        this.dataSource.sort = this.sort;    
        this.paginatorTotalLength = response.data.total;
        this.pageModelData.pageIndex = response.data.pageIndex;
        this.pageIndex = response.data.pageIndex;
        this.pageSize = this.pageModelData.pageSize
        
        if(this.sentProjectsList!=null){
         this.noRecordFound=false;
       }else{
        this.noRecordFound=true;
        this.SelectedRecordForDeleFav=false;
        this.selection.clear();
       }
       this.dialog.closeAll();
       this.loaderService.hide();
      }else{
       this.paginatorTotalLength=0;
       this.loaderService.hide();
      }
     });  
  }

 

  getCheckboxValues(event, value) {     
    if (event.checked) {
      if(value==1){
        this.sentchecked = event.checked;
      } 
      if(value==2){
        this.inProgresschecked = event.checked;
      } 
      if(value==3){
        this.completedchecked = event.checked;
      }     
    } else {
      if(value==1){
        this.sentchecked = event.checked;
      } 
      if(value==2){
        this.inProgresschecked = event.checked;
      } 
      if(value==3){
        this.completedchecked = event.checked;
      } 
    }
   
   }

  getFormsList(){
    var ReqModel = {
      isOrgAdmin: this.isOrganizationAdmin,
      isOfficeAdmin: this.isOfficeAdmin,   
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList:this.OfficeIDList    
    }
    this.formsService.getFormsList(ReqModel).subscribe(response=>{
     if(response.data!=null){      
         this.formList = response.data;
      }else{
        this.formList=[];
     }
    });
  }

  async getUserListAll() {   
    var obj={
      pageIndex : 0,
      pageSize : 500,
      searchKey : "",
      databaseID:Number(this.databaseId),
      organizationID:Number(this.organizationId),
      OfficeIDList : this.OfficeIDList,
      officeID : this.myOfficeID,
      userID:this.currentUser.UID,
    }   
    const result = await this.formsService.getUserList(obj).toPromise();     
    if (200 === this.statusConst.statusSuccess) {
      this.userListResponseHolder = result.data.userModel;
      if(this.userListResponseHolder!=null){
        this.userListResponseHolder.map((res) => {
          if (res.email != null) {
            res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.email);
          }
          // if (res.userName != null) {
          //   res.userName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.userName);
          // }
          if (res.firstName != null) {
            res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
          }
          if (res.lastName != null) {
            res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
          }
          // if (res.phoneNumber != null) {
          //   res.phoneNumber = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.phoneNumber);
          // }
          // res.tempUserRole = res.userRole;
          // if (res.userRole != null) {
          //   res.userRole = res.userRole.replace(/,/g, ', ');
          // }      
          return res;
        });      
        this.userData = result.data.userModel;//this.userListResponseHolder.data;     
        // this.totalCount = result.data.totalCount; //this.userData[0].totalCount;
        // this.presistantUserData = this.userListResponseHolder.data; // copy of the data for filteration  
        // this.pageModelData.pageIndex = result.data.pageIndex;
        // this.pageIndex = result.data.pageIndex;
        // this.pageSize = pageData.pageSize;       
      }else{
        this.userData = [];//this.userListResponseHolder.data;     
        //this.totalCount = result.data.totalCount; //this.userData[0].totalCount;
        //this.presistantUserData = []; // copy of the data for filteration  
        //this.pageModelData.pageIndex = result.data.pageIndex;
        //this.pageIndex = result.data.pageIndex;
        //this.pageSize = pageData.pageSize;       
      }
    } else {
        
    }
  }

  documentSelection(event){  
    this.documentId = event.value;     
  }

  selectedUser: any;

  sentBySelection(event){  
    this.sentby = event.value.uuid; 
    this.selectedUser = event.value.firstName+" "+event.value.lastName;    
  }

  displayUser(user: any): string {
    return user ? `${user.firstName} ${user.lastName}` : '';
  }

  formNameSelection(event){  
    this.selectedFormId = Number(event.value); 
    //this.projectDocuments=[];
    //this.GetProjectDocument(this.selectedFormId);           
  }

  GetProjectDocument(selectedFormId) {
    var ReqModel = {
      projectID: Number(selectedFormId),
      type: 2,// 1 for Project and 2 for Template
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeIDList: this.OfficeIDList,
      officeID: this.myOfficeID,
      isSent: (sessionStorage.getItem("isSent") == null || sessionStorage.getItem("isSent") == undefined) ? false : (sessionStorage.getItem("isSent") == 'true' ? true : false)
    };   
    this.formsService.GetProjectDocuments(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        if (this.ResponseHolderDetails.status == this.statusConst.statusSuccess) {             
          this.projectDocuments = response.data.documents;         
        } else {
          this.projectDocuments=[];         
        }
      } else {
        this.projectDocuments=[];
      }
    });
   }

}
